const dishesEmojis = new Map([
	['Pizza', '🍕'],
	['Burger', '🍔'],
	['Sushi', '🍣'],
	['Tacos', '🌮'],
	['Pad Thai', '🥡🦐'],
	['Pasta', '🍝'],
	['Fish and Chips', '🐟🍟'],
	['Fried Chicken', '🍗'],
	['Steak', '🥩'],
	['Hot Pot', '🍲🌶️'],
	['Curry', '🍛'],
	['Tandoori Chicken', '🍗🔥'],
	['Pho', '🍜🥩'],
	['Samosa', '🥟🌶️'],
	['Ramen', '🍜'],
	['Gyoza', '🥟'],
	['Dim Sum', '🥢🥟'],
	['Chow Mein', '🍜🥕'],
	['Peking Duck', '🦆🍚'],
	['Lasagna', '🥫🧀'],
	['Ceviche', '🐟🍋'],
	['Moussaka', '🍆🥔'],
	['Paella', '🥘🦐'],
	['Goulash', '🍲🥩'],
	['Chili Con Carne', '🌶️🥩'],
	['Fajitas', '🥙🥩'],
	['Shepherd’s Pie', '🥧🥔'],
	['Biryani', '🍚🍛'],
	['Lobster', '🦞'],
]);

export default dishesEmojis;
